import { Theme } from '@material-ui/core';
import * as factories from './factories';

export const createOverrides = (theme: Theme): Theme['overrides'] =>
  Object.values(factories)
    .map((fn) => fn(theme))
    .reduce((acc, o) => Object.assign(acc, o));
